import { render, staticRenderFns } from "./ShowDocumentItem.vue?vue&type=template&id=c426f360&scoped=true&"
import script from "./ShowDocumentItem.vue?vue&type=script&lang=js&"
export * from "./ShowDocumentItem.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=c426f360&scoped=true&lang=css&"
import style1 from "./ShowDocumentItem.vue?vue&type=style&index=1&id=c426f360&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c426f360",
  null
  
)

export default component.exports